import React from 'react';
import { Link } from 'react-router-dom';
import { preloadRoute } from '../routes';

function SmartLink({ to, onMouseEnter, onFocus, onTouchStart, ...props }) {
  const preload = () => {
    if (typeof to === 'string' && to.startsWith('/')) {
      preloadRoute(to);
    }
  };

  return (
    <Link
      to={to}
      onMouseEnter={(event) => {
        preload();
        onMouseEnter?.(event);
      }}
      onFocus={(event) => {
        preload();
        onFocus?.(event);
      }}
      onTouchStart={(event) => {
        preload();
        onTouchStart?.(event);
      }}
      {...props}
    />
  );
}

export default SmartLink;
